/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$(window).on('load', function() {
    $('body').on('click', '[data-vimeo-player-id]', function(e) {
        e.preventDefault();

        var vimeoID = $(this).data('vimeo-id'),
            links = $('[data-vimeo-player-id]'),
            player = $('[data-vimeo-player="' + $(this).data('vimeo-player-id') + '"]'),
            players = $('[data-vimeo-player]'),
            autoplay = $(this)[0].hasAttribute('data-autoplay') ? '&autoplay=1' : '';

        players.each(function() {
            $(this).attr('id', $(this).data('vimeo-player').replace('-video', '') );
            $(this).attr('src', $(this).attr('src').replace('autoplay=1', '')).removeClass('active');
        });
        links.removeClass('active');
        $(this).addClass('active');

        player.attr('src', 'https://player.vimeo.com/video/' + vimeoID + '?api=1' + '&player_id=' + player.data('vimeo-player').replace('-video', '') + autoplay).addClass('active');

        if(typeof $f !== 'undefined') {
            player.on('load', function() {
                var apiPlayer = $f(player[0]);
                apiPlayer.addEvent('finish', function() {
                    player.removeClass('active');
                    $('[data-vimeo-player-id]').removeClass('active');
                    $('#' + player.data('vimeo-player')).removeClass('active');

                    if(typeof iso !== 'undefined') {
                        iso.layout();
                    }

                    window.setTimeout (
                        function() {
                            smoothScrollTo(player[0], true);
                        },
                        2000
                    );
                });
            });
        }

        smoothScrollTo(player[0], true);
        
    });

    if(typeof $f !== 'undefined') {
        var activeLinkID = $('[data-vimeo-player-id].active').data('vimeo-player-id');
        var player = $('[data-vimeo-player="' + activeLinkID + '"]');
        var apiPlayer = $f(player[0]);

        apiPlayer.addEvent('ready', function() {
            apiPlayer.addEvent('finish', function() {
                player.removeClass('active');
                $('[data-vimeo-player-id]').removeClass('active');
                $('#' + activeLinkID).removeClass('active');

                if(typeof iso !== 'undefined') {
                    iso.layout();
                }

                window.setTimeout (
                    function() {
                        smoothScrollTo(player[0], true);
                    },
                    2000
                );
            });
        });
    }

    // make a link stop all [data-vimeo-player]
    $('body').on('click', '[data-vimeo="stop"]', function(e){
        e.preventDefault();

        $('[data-vimeo-player]').attr('src', '').removeClass('active');
        $('[data-vimeo-player-id]').removeClass('active');
    });

    var videoSlug = window.videoSlug || window.location.hash.replace('#', '');
    if($('[href="#' + videoSlug + '-video"]').not('[data-vimeo="stop"]').length) {
        var link = $('[href="#' + videoSlug + '-video"]').not('[data-vimeo="stop"]'),
            container = $('#' + videoSlug + '-video'),
            player = $('[data-vimeo-player="' + link.data('vimeo-player-id') + '-video"]');

        deactivateVideos();
        link.trigger('click');
        container.addClass('active');

        if(typeof iso !== 'undefined') {
            iso.layout();
        }

        setTimeout(function() {
            $('html, body').animate({
                scrollTop: (link.offset().top - 480) + 'px'
            }, 2000);
        }, 2000);
    }

});
